export default __webpack_public_path__ + "static/media/croptop-large-back-toosmall.63e05ca9.jpg";